import Vue from 'vue'

export default {
    config: (targetId, configParams) => {
        if (window.gtag) {

            //CHECK REF COOKIE
            let cookie_lastref = Vue.cookie.get("MMD_LastRef");
            if (cookie_lastref) {
                configParams.dimension1 = cookie_lastref.toLowerCase();
            }

            window.gtag('config', targetId, configParams);
        }
    },
    set: (setParams) => {
        if (window.gtag) {
            window.gtag('set', setParams);
        }
    },
    event: (eventName, eventParams) => {
        if (window.gtag) {

            //CHECK REF COOKIE
            let cookie_lastref = Vue.cookie.get("MMD_LastRef");
            if (cookie_lastref) {
                eventParams.dimension1 = cookie_lastref.toLowerCase();
            }

            window.gtag('event', eventName, eventParams);
        }
    }
}